var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22.4199,
    r: 22,
    fill: "#0A7CC1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1564 31.0914L17.1566 31.0915C19.3114 32.2455 21.5922 32.5826 24.0129 32.1187C26.0081 31.7362 27.6923 30.7874 29.1504 29.3786C30.9752 27.6148 32.8066 25.8565 34.6369 24.0993C35.3282 23.4355 36.0194 22.7719 36.71 22.1082C36.1457 21.5653 35.5815 21.0224 35.0174 20.4797C33.0265 18.564 31.0365 16.6491 29.042 14.7375L29.0419 14.7374C27.5163 13.2749 25.7101 12.3568 23.5833 12.0291L17.1564 31.0914ZM17.1564 31.0914C16.3067 30.6366 15.5517 30.0363 14.8276 29.3409C12.3195 26.9288 9.81068 24.518 7.30193 22.1079M17.1564 31.0914L7.30193 22.1079M7.30193 22.1079C7.71058 21.7156 8.11939 21.3233 8.52827 20.9308C10.5688 18.9725 12.6111 17.0125 14.6448 15.0448L14.6448 15.0447C15.6828 14.0403 16.7829 13.2186 18.0737 12.6888L7.30193 22.1079ZM18.0739 12.6887C19.8495 11.9605 21.6804 11.7359 23.5833 12.029L18.0739 12.6887Z",
    fill: "url(#paint0_linear_60_152)",
    stroke: "url(#paint1_linear_60_152)",
    strokeWidth: 1.80769
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.236 21.1262C19.7535 21.6647 20.31 22.2438 20.8685 22.8248C22.2047 21.5271 23.5118 20.2561 24.806 19C25.3425 19.5395 25.8899 20.0888 26.4444 20.6461C24.5998 22.4427 22.7241 24.269 20.8335 26.1111C19.7715 25.0243 18.6575 23.8839 17.5555 22.7565C18.057 22.2695 18.6145 21.728 19.235 21.1262H19.236Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_60_152",
    x1: 7.80658,
    y1: 31.969,
    x2: 26.2791,
    y2: 5.36977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_60_152",
    x1: 8.25884,
    y1: 12.7482,
    x2: 25.2684,
    y2: 38.9366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 22.2222,
    fill: "white",
    transform: "translate(6 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThree);
export default __webpack_public_path__ + "static/media/three.3e110d445ede53b9ab17fd36c2be9946.svg";
export { ForwardRef as ReactComponent };